import React from 'react';
import {StyledInputLabel} from './style';

const InputLabel = ({children}) => {
  return (
  <StyledInputLabel>{children}</StyledInputLabel>
  );
}

export default InputLabel;